
export default function RecruitHero() {
  return (
    <div className="relative h-[45vh] sm:h-[60vh] flex items-center justify-center">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1cedd7c3b260f8dd0891b5e7bf2a2f4a.jpg"
          alt="正社員募集"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center text-white px-4 sm:px-6">
        <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold drop-shadow-[0_4px_8px_rgba(0,0,0,0.5)]">
          正社員募集
        </h1>
        <p className="mt-4 text-base sm:text-xl font-medium drop-shadow-[0_2px_6px_rgba(0,0,0,0.5)]">
          営業職・現場職人 積極採用中
        </p>
      </div>
    </div>
  );
}
